<template>
  <div>
    <div class="card-deck mb-3 text-center row">
      <Spinner v-if="isLoading" />
      <div class="card mb-6 box-shadow">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">月額プラン<small class="badge badge-primary ml-2" v-if="c_vars.plan === 0">契約中</small></h4>
        </div>
        <div class="card-body">
          <h1 class="card-title pricing-card-title"><small>￥</small>500</h1>
          <button v-if="c_vars.plan !== 0" data-toggle="modal" data-target="#modelId" type="button" @click="upgrade(0)" class="btn btn-lg btn-block btn-outline-primary">選択する</button>
          <button v-else data-toggle="modal" data-target="#cancelModal" type="button" class="btn btn-lg btn-block btn-danger">プランを解約する</button>
        </div>
      </div>
      <div class="card mb-6 box-shadow">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">年額プラン<small class="badge badge-primary ml-2" v-if="c_vars.plan === 1">契約中</small></h4>
        </div>
        <div class="card-body">
          <h1 class="card-title pricing-card-title"><small>￥</small>5,000</h1>
          <button v-if="c_vars.plan !== 1" data-toggle="modal" data-target="#modelId" type="button" @click="upgrade(1)" class="btn btn-lg btn-block btn-primary">選択する</button>
          <button v-else data-toggle="modal" data-target="#cancelModal" type="button" class="btn btn-lg btn-block btn-danger">プランを解約する</button>
        </div>
      </div>
    </div>
    
    <!-- Modal -->
    <div class="modal fade" id="modelId" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">カード情報登録</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label for="name_kana" class="col-md-4 col-form-label text-md-right">カード名義人</label>

              <div class="col-md-6">
                <input id="card-holder-name" disabled :value="c_vars.user.name" class="form-control" type="text" />
              </div>
            </div>
            <div id="card-element"></div>
          </div>
          <div class="modal-footer">
            <button id="card-button" type="button" class="btn btn-primary">登録する</button>
            <form action="/mypage/plans" method="post" id="plansSelectForm">
              <input type="hidden" name="_token" :value="csrf">
              <input type="hidden" name="_stripe_token" :value="token">
              <input type="hidden" name="payment_method" id="payment_method">
              <input type="hidden" name="product_id" :value="plan">
              <input type="hidden" name="user_id" :value="c_vars.user_id">
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="cancelModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              本当に解約しますか？
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form__row">
              <p>
                ※解約と同時に有料プランの機能が使用不可になります。<br/>無料会員として引き続きご利用いただけます。
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button id="card-button" type="button" data-toggle="dismiss" class="btn btn-primary">キャンセル</button>
            <button id="card-button" type="button" @click="cancel" class="btn btn-danger">解約する</button>
            <form action="/mypage/cancel_plans" method="post" id="cancelPlanForm">
              <input type="hidden" name="_token" :value="csrf">
              <input type="hidden" name="user_id" :value="c_vars.user_id">
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

import Spinner from './Spinner.vue'

export default {
  components: {
    Spinner,
  },
  props: ['cartvars'],
  data () {
    // this.publishableKey = 'pk_live_51NYiotHVUgES1XDz2nJ8x7gsnE5lysSfyBT6gAch4vZEIrnYwY8df5alUQIFCuvTLg7MtdbFZtQYVjyfC5WlD3I300CjELgn3Z';
    this.publishableKey = process.env.MIX_STRIPE_KEY;
    return {
      token: null,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      plan: -1,
      c_vars: JSON.parse(this.cartvars),
      payment_method: '',
      isLoading: false
    };
  },
  mounted () {
    this.init()
  },
  methods: {
    submit () {
      // this will trigger the process
    },
    tokenCreated (token) {
    },
    upgrade (plan) { 
      this.plan = plan
    },
    async init () {
      setTimeout(() => {
        // const stripe = Stripe('pk_live_51NYiotHVUgES1XDz2nJ8x7gsnE5lysSfyBT6gAch4vZEIrnYwY8df5alUQIFCuvTLg7MtdbFZtQYVjyfC5WlD3I300CjELgn3Z');
        const stripe = Stripe(process.env.MIX_STRIPE_KEY);
        const elements = stripe.elements();
        const cardElement = elements.create('card', {
          hidePostalCode: true
        });
        cardElement.mount('#card-element');
        const cardHolderName = document.getElementById('card-holder-name');
        const cardButton = document.getElementById('card-button');
        const clientSecret = cardButton.dataset.secret;
        cardButton.addEventListener('click', async (e) => {
          this.isLoading = true
          const { setupIntent, error } = await stripe.confirmCardSetup(
              this.c_vars.intent.client_secret, {
                  payment_method: {
                      card: cardElement,
                      billing_details: { name: cardHolderName.value }
                  }
              }
          );
          this.isLoading = false
          if (error) {
              // Display "error.message" to the user...
          } else {
            this.payment_method = setupIntent.payment_method
            $('#payment_method').val(setupIntent.payment_method)
            $('#plansSelectForm').submit()
              // The card has been verified successfully...
          }
        });
      }, 300)
    },
    cancel () {
      this.isLoading = true
      $('#cancelPlanForm').submit()
    }
  }
};
</script>